<template>
  <div class="small-title-box" :class="{ 'has-tag': tag }">
    <div :style="{'margin-top': marginTop}" class="doc" />
    <p class="content " :class="rows > 1 ? 'clampTow': ''" :style="{'-webkit-line-clamp':rows,'line-height':lineHeight}">{{ title }}</p>
    <div v-if="time || tag" class="time-box">
      <p v-if="time" class="time">{{ time }}</p>
      <span v-if="tag" class="tag">{{ tag }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmallTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    time: {
      type: String,
      default: ''
    },
    // 时间下方的标识文案（如「涉黔」），为空则不渲染，不影响其他调用方
    tag: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      default: 1
    },
    lineHeight: {
      type: String,
      default: '20px'
    },
    marginTop: {
      type: String,
      default: '0px'
    }
  },
  data() {
    return {
    };
  }
};
</script>

<style lang="less" scoped>
.small-title-box {
  width: 100%;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px dashed #E5E5E5;
  &:hover .doc{
    background: #008BF2;
  }
  .doc{
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #CCCCCC;
    margin-right: 7px;
  }
  .content {
    flex: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    font-size: 16px;
    color: #000;
    font-family: '宋体';
    position: relative;
    line-height: 20px;
  }
  .clampTow {

  }
  .clampTow::after{
    content: "..."; position: absolute; bottom: 0; right: 0; padding-left: 40px;
    background: -webkit-linear-gradient(left, transparent, #fff 55%);
    background: -o-linear-gradient(right, transparent, #fff 55%);
    background: -moz-linear-gradient(right, transparent, #fff 55%);
    background: linear-gradient(to right, transparent, #fff 55%);}

  .content:hover {
    // color: #367dbe;
    // text-decoration: underline;
  }
  .time-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-left: 30px;
  }
  .time {
    min-width: 60px;
    line-height: 20px;
    font-size: 14px;
    color: #999999;
  }
  .tag {
    margin-top: 2px;
    padding: 0 6px;
    font-family: '宋体';
    font-size: 12px;
    line-height: 18px;
    color: #ffffff;
    background: #e60012;
    border-radius: 4px;
    white-space: nowrap;
  }
  // 带标识时缩小上下内边距，保证整行高度与普通行一致（20*2+20+1 === 10*2+40+1 === 61px）
  // 从而不会撑高「最新发布」等固定高度容器，避免末条被裁剪
  &.has-tag {
    padding: 10px 0;
  }
}
</style>
